import { createSlice } from '@reduxjs/toolkit';

/**
 * Initial state for the plans module in Redux.
 */
const initialState = {
    planList: null,             // Stores list of subscription/plans
    planListLoader: false       // Boolean loader flag for fetching plan list
};

/**
 * Redux slice to manage state related to plans/subscription options.
 */
const plansSlice = createSlice({
    name: 'plans',
    initialState,
    reducers: {
        /**
         * Sets the list of plans.
         * @param {Object} state 
         * @param {Object} action - Array or object containing plan data.
         */
        setPlanList: (state, action) => {
            state.planList = action.payload;
        },

        /**
         * Toggles the loading state while fetching plans.
         * @param {Object} state 
         * @param {Object} action - Boolean loader value.
         */
        setPlanListLoader: (state, action) => {
            state.planListLoader = action.payload;
        }
    },

    /**
     * Optional global state reset.
     * Consider replacing this with a typed action.
     */
    extraReducers: (builder) => {
        builder.addCase('RESET_STATE', () => initialState);
    }
});

// Export action creators
export const {
    setPlanList,
    setPlanListLoader
} = plansSlice.actions;

// Export reducer
export default plansSlice.reducer;
